import PortalDuck from '@aytm/app/insights/dashboard/duckness/ducks/PortalDuck/PortalDuck'
import { PORTAL_ACTIONS } from '@aytm/app/insights/dashboard/duckness/ducks/PortalDuck/PortalDuck.actions'
import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import type { DashboardSchemaModelShape } from '@aytm/app/insights/dashboard/models/DashboardSchemaModel'
import type { ComponentStoreState } from '@aytm/app/insights/dashboard/stores/ComponentStoreState'

export const makeActivateViewPortalAction = (reportId: string) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.ACTIVATE_VIEW, { uid: reportId }] as DuckActionPayloadTuple<{ uid: string }>

export const makeRevertCurrentViewPortalAction = () =>
  [PortalDuck.duckName, PORTAL_ACTIONS.REVERT_CURRENT_VIEW, {}] as DuckActionPayloadTuple<{}>

export const makeReplaceViewPortalAction = (from: string, to: string, views: string[], append?: boolean) =>
  [
    PortalDuck.duckName,
    PORTAL_ACTIONS.REPLACE_VIEW,
    {
      source: from,
      target: to,
      views,
      append: Boolean(append)
    }
  ] as DuckActionPayloadTuple<{ source: string; target: string; views: string[]; append: boolean }>

export const makeSaveCurrentViewPortalAction = (patch?: { title?: string | null }) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.SAVE_CURRENT_VIEW, patch ? { patch } : {}] as DuckActionPayloadTuple<
    { patch: { title: string } } | {}
  >

export const makeAddViewPortalAction = (title: string) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.ADD_VIEW, { patch: { title } }] as DuckActionPayloadTuple<{
    patch: { title: string }
  }>

export const makeDeleteViewPortalAction = (uid: string) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.DELETE_VIEW, { uid }] as DuckActionPayloadTuple<{ uid: string }>

export const makeUpdateDataPortalAction = (updates: Partial<ComponentStoreState>) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.UPDATE_DATA, updates] as DuckActionPayloadTuple<Partial<ComponentStoreState>>

export const makeUpdateSchemaShowSidebarPortalAction = (showSidebar: boolean) =>
  [
    PortalDuck.duckName,
    PORTAL_ACTIONS.UPDATE_SCHEMA,
    {
      showSidebar
    }
  ] as DuckActionPayloadTuple<{ showSidebar: boolean }>

export const makeUpdateSchemaPortalAction = (updates: Partial<DashboardSchemaModelShape>) =>
  [PortalDuck.duckName, PORTAL_ACTIONS.UPDATE_SCHEMA, updates] as DuckActionPayloadTuple<
    Partial<DashboardSchemaModelShape>
  >

export const makeRestorePortalAction = () =>
  [PortalDuck.duckName, PORTAL_ACTIONS.REVERT_SOURCES] as DuckActionPayloadTuple

export const makeSaveSourcesPortalAction = () =>
  [PortalDuck.duckName, PORTAL_ACTIONS.SAVE_SOURCES] as DuckActionPayloadTuple
